import { headers, jsonMimes } from "../../../utils/mimes";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const fetchDataFromServer = (...args: Parameters<typeof fetch>): Promise<Response> => {
  const [input, init = {}] = args;

  /*                                   */
  /*                                                                 */
  init.cache ??= "no-cache";

  /*                                     */
  init.headers = new Headers(init.headers);

  /*                                   */
  init.headers.set(headers[1], jsonMimes[0]);
  /*                                                */
  init.headers.set(headers[3], "true");

  return fetch(input, init);
};
